import { TRANSCRIPTOR_LANGUAGE } from '@/entities/transcriptor';

export enum RecordingStep {
  Initial = 'initial',
  Settings = 'settings',
  Configure = 'configure',
  Recording = 'recording',
}

export enum RecordingMethod {
  Record = 'record',
  Microphone = 'microphone',
  Upload = 'upload',
}

export type MicrophoneDevice = {
  deviceId: string;
  label: string;
  groupId: string;
};

export type RecordingState = {
  isRecording: boolean;
  isPaused: boolean;
  recordingTime: number;
  audioBlob?: Blob;
  audioUrl?: string;
};

export type TranscriptorRecordingState = {
  recordingMethod: RecordingMethod;
  language: TRANSCRIPTOR_LANGUAGE;
  uploadedFile: File | null;
  isUploading: boolean;
  uploadError: string | null;
  isProcessing: boolean;
  processingError: string | null;
};

export type TranscriptorPreferences = {
  schemaId: string;
  templateSeriesIds: string[];
  recordingMethod: RecordingMethod;
  language: TRANSCRIPTOR_LANGUAGE;
};

export type UseTranscriptorPreferencesReturn = {
  preferences: TranscriptorPreferences;
  updatePreferences: (updates: Partial<TranscriptorPreferences>) => void;
  resetPreferences: () => void;
};
